import ProvidedJobPostsMatchingCard from './ProvidedJobPostsMatchingCard';

type Props = {
  jobPostId: number;
};

export default function ProvidedJobPostsJobChangeProcessesCard({ jobPostId }: Props) {
  return <ProvidedJobPostsMatchingCard jobPostId={jobPostId} />;
}
